export default __webpack_public_path__ + "static/media/imdb.60b7b8dd.png";